import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';

import StoreName        from '../../../../State/Shared/Constants/StoreName';
import IPlayerStores    from '../../../../State/Shared/Interfaces/IPlayerStores';
import Playback         from '../../../../State/Stores/Playback/Playback';
import {PLAYER_POSTER}  from '../../../Shared/Constants/TestIds';
import composeTokenList from '../../Util/composeTokenList';
import renderTestId     from '../../Util/renderTestId';

import * as styles from './poster.css';

@connect(StoreName.PLAYBACK)
class Poster extends React.Component<IConnectProps<Playback, IPlayerStores>> {
    public shouldComponentUpdate(nextProps: IConnectProps<Playback, IPlayerStores>): boolean {
        const {value: nextValue} = nextProps;
        const {value: prevValue} = this.props;

        return (
            nextValue.isLoading !== prevValue.isLoading ||
            nextValue.isAtEndAndStopped !== prevValue.isAtEndAndStopped ||
            nextValue.hasErrored !== prevValue.hasErrored
        );
    }

    public render(): JSX.Element {
        const {isAtEndAndStopped, hasErrored, isLoading} = this.props.value;

        const className = composeTokenList([
            styles.poster,
            [isAtEndAndStopped || hasErrored || isLoading, styles.posterShown]
        ]);

        return (
            <div
                className={className}
                data-test-id={renderTestId(PLAYER_POSTER)}
                style={this.renderBackgroundImageStyle()}
            />
        );
    }

    private getBackgroundImageUrl(): string {
        const {stores, value: {hasErrored}} = this.props;
        const {fallbackImageUrl} = stores.config.value.behaviour;
        const {posterUrl} = stores.media.value;

        return (hasErrored ? fallbackImageUrl : posterUrl) || fallbackImageUrl;
    }

    private renderBackgroundImageStyle(): React.CSSProperties {
        const url = this.getBackgroundImageUrl();

        return {
            backgroundImage: url ? `url(${url})` : 'none'
        };
    }
}

export default Poster;